package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class SummarizePlayerAssessmentResponse(
    val sessionsAnalyzed: Int? = null,
    val summary: String? = null,
    val message : String?= null,
    val error: String?= null
)

@Serializable
data class SummarizeAssessmentPayload(
    val organization: String,
    val playerID: String,
    val domainType: String,
    val language: String,
    val seasonID : String
)